import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

export default function PageHero({ eyebrow, titleLines, paragraphs, image, testid }) {
  return (
    <section className="relative overflow-hidden pt-40 pb-24 lg:pt-48 lg:pb-32" data-testid={testid}>
      {image && (
        <div className="absolute inset-0" aria-hidden="true">
          <motion.img
            src={image}
            alt=""
            initial={{ scale: 1.12, opacity: 0 }}
            animate={{ scale: 1, opacity: 0.22 }}
            transition={{ duration: 2, ease: [0.22, 1, 0.36, 1] }}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-obsidian/70 via-obsidian/85 to-obsidian" />
          <div className="absolute inset-0 hud-lines opacity-40" />
        </div>
      )}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="font-mono text-[11px] sm:text-xs font-bold tracking-[0.3em] uppercase text-sovereign flex items-center gap-3">
            <span className="w-8 h-px bg-sovereign/60" aria-hidden="true" />
            {eyebrow}
          </p>
        </Reveal>
        <h1 className="mt-6 font-display font-extrabold uppercase tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl max-w-4xl" data-testid={`${testid}-title`}>
          {titleLines.map((l, i) => (
            <span key={i} className="block overflow-hidden pb-1">
              <motion.span
                className="block"
                initial={{ y: "115%" }}
                animate={{ y: 0 }}
                transition={{ duration: 0.9, delay: 0.2 + i * 0.15, ease: [0.19, 1, 0.22, 1] }}
              >
                {l}
              </motion.span>
            </span>
          ))}
        </h1>
        {paragraphs && (
          <div className="mt-8 max-w-2xl space-y-4">
            {paragraphs.map((p, i) => (
              <Reveal key={i} delay={0.4 + i * 0.1}>
                <p className="text-base sm:text-lg text-slate-300 leading-relaxed">{p}</p>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
